// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chimney"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M9 21V14L15 11L21 14V21H9Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 21L4 7L3 3H12L11 7L11.5 12.75L9 14V21H3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 7L3 21H9V14L11.5 12.75L11 7M4 7L3 3H12L11 7M4 7H11M15 18V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 21V14L15 11L21 14V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChimneyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chimney',
    ref,
    icon: element,
  },
));

ChimneyIcon.displayName = 'ChimneyIcon';

export default ChimneyIcon;
